import { Box, Typography, Button } from '@mui/material';
import React, { useContext } from 'react';
import Header from '../components/Header';
import PrimaryButton from '../components/PrimaryButton';
import ErrorImage1 from '../assets/Group 7389.png';
import ErrorImage2 from '../assets/Group 7389@2x.png';
import ErrorImage3 from '../assets/Group 7389@3x.png';
import { DataContext } from '../contexts/DataContext';

function ErrorPage() {
  const { uploadFile } = useContext(DataContext);

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
      }}
    >
      <Header />
      <Box
        sx={{
          flex: 1,
          height: 'calc( 90vh - 73px )',
          maxHeight: '684px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'stretch',
          paddingInline: '32px',
          paddingBottom: '66px',
          paddingTop: '35px',
          gap: '64px',
        }}
      >
        <Box
          sx={{
            height: '229px',
            minHeight: '229px',
            boxShadow: '0px -1px 24px 0px rgba(0, 0, 0, 0.04)',
            borderRadius: '20px',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0px',
            paddingInline: '10px',
          }}
        >
          <img
            src={ErrorImage1}
            srcSet={`
       ${ErrorImage1} 1x,
       ${ErrorImage2} 2x,
       ${ErrorImage3} 3x
     `}
            alt="landingpageimage"
            style={{
              width: '61px',
              height: 'auto',
              objectFit: 'cover',
              marginTop: '10px',
            }} // Adjust size as needed
          />
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: '700',
              lineHeight: '25px',
              textAlign: 'center',
              color: '#DD2430',
            }}
          >
            We can not detect any H&S shampoos{' '}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: '8px',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <div
              style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                background: '#DD2430',
              }}
            ></div>{' '}
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: '700',
                lineHeight: '19.23px',
                textAlign: 'left',
                color: '#33303C',
                flex: 1,
              }}
            >
              Please make sure the camera is focused when taking the
              picture.{' '}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '8px',
          }}
        >
          <PrimaryButton
            onClick={() => {
              uploadFile();
            }}
          >
            Retake the photo
          </PrimaryButton>
          <Button
            variant="text"
            sx={{ fontSize: '14px', fontWeight: '700', color: '#33303C' }}
            onClick={() => (window.location.href = '/')}
          >
            QUIT
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default ErrorPage;
